export default __webpack_public_path__ + "static/media/port7.6bda8c52.png";